import { Component } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { McService } from 'client/app/shared/components/message-center/mc.service';
import { catchError, tap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ISitemap } from '@neb/lit-storybook';
import { EnumMessageCenterFolders } from 'client/app/shared/constants';
import { GemsService } from 'client/app/shared/services';

interface IContent {
  siteMap: ISitemap;
  unreadCount: number;
  errorStatus?: number;
}

@Component({
  selector: 'app-admin-root',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.less'],
  standalone: false
})
export class AdminAppComponent {
  showMenu: boolean = true;
  cssTable = "container-gray";
  title = 'Benefit Plan Rating';

  content$: Observable<IContent> = forkJoin({
    siteMap: this.gemsService.siteMap(),
    unreadCount: this.mcService.unreadCount(EnumMessageCenterFolders.INBOX),
    banners: this.gemsService.getBannerAlerts()
  }).pipe(
    tap(x => console.log('content', x)),
    catchError((e: HttpErrorResponse) => {
      return of({ errorStatus: e.status } as IContent);
    })
  );

  constructor(
    private mcService: McService,
    private gemsService: GemsService
  ) { }
}
